export default __webpack_public_path__ + "static/media/awardStar.27e553f2.svg";